import { Button } from '@cencosud-cencommerce/paris-uikit';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { useGtmBillingProduct as useGtm } from '@/modules/perseo-billing/hooks/use-gtm-billing';

import { PAYMENT_METHODS } from '../../constants/src/providers/payment-methods';
import { usePayment } from '../../hooks/use-payment';
import type { IPaymentButton } from '../../interfaces';

import { useIsMutatingOrder } from './hooks';
import { useButtonText } from './use-button-text';

export const PaymentButton = (props: IPaymentButton) => {
  const { label, method, customHandler, ...rest } = props;

  const billing = useAppSelector((state) => state.billing);
  const isPaymentAvailable = billing.isPaymentAvailable;

  const isWebpay = method === PAYMENT_METHODS.WEBPAY;
  const isCencoPay = method === PAYMENT_METHODS.CENCOPAY;

  const { continueWithWebpayGtm, cencoPaySavedCardsGtm } = useGtm();
  const { handleSubmitForm } = usePayment();

  const buttonLabel = useButtonText(method);
  const buttonText = label ?? buttonLabel;

  const { isMutating } = useIsMutatingOrder();

  const clickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    customHandler && customHandler();
    isWebpay && continueWithWebpayGtm();
    isCencoPay && cencoPaySavedCardsGtm();
    handleSubmitForm();
  };

  return (
    <Button
      id="submit-button-mobile"
      onClick={clickHandler}
      disabled={!isPaymentAvailable}
      type="submit"
      loading={isMutating}
      {...rest}
    >
      {buttonText}
    </Button>
  );
};
